import React, { type ReactNode } from 'react';

import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts';

import type { NavItemConfig } from '../../types';

export const getMenuLabelAndIcon =
	(items: Record<string, NavItemConfig>, shortcuts: Record<string, GlobalShortcutsItem>) =>
	(menuId: string): { label: string; icon: ReactNode } => {
		const item = items[menuId];

		if (item) {
			// Temporary until name and icon can be made required
			const label = item.name ?? 'unknown';
			const icon = item.icon ?? <QuestionCircleIcon label="" />;

			return { label, icon };
		}

		const shortcut = shortcuts[menuId];

		if (shortcut) {
			return { label: shortcut.label, icon: shortcut.icon };
		}

		throw Error(`Menu id ${menuId} not found in either items or shortcuts`);
	};
